import { Link } from "react-router-dom";
import { toast } from "sonner";
import { FlaskConical } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const DemoBanner = () => {
  const { user } = useAuth();
  if (!user?.business?.sandbox) return null;
  const isAdmin = user.tenant_role === "admin";

  const switchTo = async (role) => {
    try {
      await api.post("/demo/switch", { role });
      window.location.assign(role === "admin" ? "/app" : "/me");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 bg-indigo-600 px-4 py-2.5 text-sm text-white" data-testid="demo-banner">
      <span className="flex items-center gap-2 font-medium">
        <FlaskConical className="h-4 w-4 shrink-0" />
        <span className="hidden sm:inline">Live demo: you're {isAdmin ? "the manager" : `${user.name} (staff)`}. Sample data, private to you, deleted after 24 hours. No emails are sent.</span>
        <span className="sm:hidden">Demo: {isAdmin ? "manager" : user.name}</span>
      </span>
      <span className="flex items-center gap-2">
        <button onClick={() => switchTo(isAdmin ? "staff" : "admin")} className="rounded-full bg-white/15 px-3 py-1 text-xs font-semibold transition-colors hover:bg-white/25" data-testid="demo-switch-btn">
          {isAdmin ? "View as staff" : "View as manager"}
        </button>
        <Link to="/signup" className="rounded-full bg-white px-3 py-1 text-xs font-bold text-indigo-700 hover:bg-indigo-50" data-testid="demo-signup-btn">Start free</Link>
      </span>
    </div>
  );
};
